import AntIcon from "@ant-design/icons"
import { type IconComponentProps } from "@ant-design/icons/lib/components/Icon"
import React from "react"

import { svg } from "./img"

interface IconProps extends IconComponentProps {
  type: keyof typeof svg
}

const Icon = ({ type, ...props }: IconProps) => {
  const IconComp = svg?.[type]
  return <AntIcon component={IconComp} {...props} />
}

export default Icon
